import React from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";

import { WoshModal } from "../Feedback";

/**
 * Pop-up 05 — changement d'adresse. Une autre adresse peut dépendre d'un autre
 * partenaire blanchisseur, donc d'autres prix : le panier en cours est vidé.
 * C'était déjà le cas avant la refonte ; seule l'interface change.
 *
 * @param {boolean}  open
 * @param {function} onClose
 * @param {function} handleSubmit  Applique l'adresse choisie (voir Header).
 */
const ChangeAddress = ({ open, onClose, handleSubmit }) => {
  const { t } = useTranslation();
  const history = useHistory();

  return (
    <WoshModal
      open={open}
      onClose={onClose}
      closable
      closeLabel={t("Close")}
      icon={
        <svg viewBox="0 0 512 512" aria-hidden="true">
          <path
            d="M256,48c-79.5,0-144,61.39-144,137,0,87,96,224.87,131.25,272.49a15.77,15.77,0,0,0,25.5,0C304,409.89,400,272.07,400,185,400,109.39,335.5,48,256,48Z"
            style={{
              fill: "none",
              stroke: "currentColor",
              strokeLinecap: "round",
              strokeLinejoin: "round",
              strokeWidth: "32px",
            }}
          />
          <circle
            cx="256"
            cy="192"
            r="48"
            style={{
              fill: "none",
              stroke: "currentColor",
              strokeLinecap: "round",
              strokeLinejoin: "round",
              strokeWidth: "32px",
            }}
          />
        </svg>
      }
      title={t("Changing address?")}
      lede={t(
        "Your new address could potentially be associated with another WOSH Laundry Partner. In such a scenario, there is a chance that product prices may vary slightly."
      )}
      warning={t("As a result, your current basket will be deleted.")}
      cancelLabel={t("No, back")}
      confirmLabel={t("Yes, proceed")}
      onConfirm={() => {
        handleSubmit();
        onClose();
        history.push("/");
      }}
    />
  );
};

export default ChangeAddress;
